// extracted by mini-css-extract-plugin
module.exports = {"defaultPreamble":"DefaultPreamble-module--default-preamble--1E709"};